import type { InferRpcDefinition } from "@redotech/rpc/definition";
import {
  createCsatSurveyTemplate,
  getCsatResponsesForConversation,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
  getCsatSurveyTemplates,
  getCsatVariantStats,
} from "./schema/csat";
import { deleteRecordingFromCallRecord } from "./schema/delete-recording-from-call-record";
import { getCallRecordWithTranscript } from "./schema/get-call-record-with-transcript";
import { getConversationInsights } from "./schema/get-conversation-insights";
import { getConversationInsightsCount } from "./schema/get-conversation-insights-count";
import { getConversationTagsById } from "./schema/get-conversation-tags-by-ids";
import { getSupportAiPricing } from "./schema/get-support-ai-pricing";
import { grantFreeTrialCredits } from "./schema/grant-free-trial-credits";
import { hasReachedConversationThreshold } from "./schema/has-reached-conversation-threshold";
import { manuallyConvertChatToEmail } from "./schema/manually-convert-chat-to-email";
import { getPhoneNumberForTeam } from "./schema/phone-number";
import { polishMessage } from "./schema/polish-message";
import { searchTelnyxPhoneNumbers } from "./schema/search-telnyx-phone-numbers";
import { setupPhoneNumber } from "./schema/setup-phone-number";
import { getTelnyxTelephonyToken } from "./schema/telnyx-telephony-token";
import { toggleCallBeingRecorded } from "./schema/toggle-call-being-recorded";
import { toggleCallOnHold } from "./schema/toggle-call-on-hold";
import { turnOnSupportDefaults } from "./schema/turn-on-support-defaults";
import { updateAiFeedbackOnMessage } from "./schema/update-ai-feedback-on-message";
import { updateSupportSettings } from "./schema/update-support-settings";

export const supportMerchantRpcDefinition = {
  deleteRecordingFromCallRecord,
  getCallRecordWithTranscript,
  createCsatSurveyTemplate,
  getCsatResponsesForConversation,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
  getCsatSurveyTemplates,
  getCsatVariantStats,
  getPhoneNumberForTeam,
  getSupportAiPricing,
  getTelnyxTelephonyToken,
  hasReachedConversationThreshold,
  manuallyConvertChatToEmail,
  polishMessage,
  searchTelnyxPhoneNumbers,
  setupPhoneNumber,
  toggleCallBeingRecorded,
  toggleCallOnHold,
  turnOnSupportDefaults,
  updateAiFeedbackOnMessage,
  updateSupportSettings,
  getConversationTagsById,
  getConversationInsights,
  getConversationInsightsCount,
  grantFreeTrialCredits,
} as const;

export type SupportMerchantRpcDefinition = InferRpcDefinition<
  typeof supportMerchantRpcDefinition
>;
